import React from 'react';
import { Checkbox } from 'antd';

const CheckboxCustom = ({ label, render, marginBottom, ...rest }) => (
    <Checkbox 
        {...rest}
        className={`checkbox margin-bottom${marginBottom}`} 
    >{label} {render}</Checkbox>
);

export default CheckboxCustom;